import {accordions} from './init-accordion';
import {createElement, nanoid} from '../utils/utils';
import FormsValidate from './form/form-validate';

const MAX_EMPLOYERS = 20;

const wrapper = document.querySelector('.account-aside');

const createEmployerTemplate = () => {
  const id = nanoid(5);
  return (
    `<li class="account-aside__employers-item active js-not-ready">
      <div class="employer-form account-aside__employer-form" data-validate data-callback="employerForm">
        <form method="post">
          <div class="employer-form__wrapper">
            <div class="employer-form__fields">
              <div class="employer-form__field">
                <div class="custom-input custom-input--no-label" data-validate-type="phone">
                  <label>
                    <input type="tel" id="employer-${id}-phone" name="employer-${id}-phone" value="" placeholder="Телефон" size="1">
                  </label>
                  <div class="custom-input__error" data-error data-required-text="Заполните поле" data-text="*Неверный ввод">*Неверный ввод</div>
                </div>
              </div>
              <div class="employer-form__field">
                <div class="custom-input custom-input--no-label">
                  <label>
                    <input type="text" id="employer-${id}-name" name="employer-${id}-name" value="" placeholder="Имя и фамилия" size="1">
                  </label>
                  <div class="custom-input__error" data-error data-required-text="Заполните поле" data-text="*Неверный ввод">*Неверный ввод</div>
                </div>
              </div>
            </div>
            <div class="employer-form__btns-wrapper">
              <button class="btn-reset tooltip employer-form__btn employer-form__btn--submit" type="submit" data-tooltip="Сохранить"><span class="visually-hidden">Сохранить</span>
                <svg width="20" height="20" aria-hidden="true">
                  <use xlink:href="#icon-ok"></use>
                </svg>
              </button>
              <button class="btn-reset tooltip employer-form__btn employer-form__btn--delete" type="button" data-tooltip="Удалить"><span class="visually-hidden">Удалить</span>
                <svg width="15" height="16" aria-hidden="true">
                  <use xlink:href="#icon-delete"></use>
                </svg>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="employer-info account-aside__employer-info">
        <div class="employer-info__user">
          <div class="employer-info__phone"></div>
          <div class="employer-info__name"></div>
        </div>
        <button class="btn-reset employer-info__edit-btn"><span class="visually-hidden">Редактировать</span>
          <svg width="14" height="14" aria-hidden="true">
            <use xlink:href="#icon-edit"></use>
          </svg>
        </button>
      </div>
    </li>`);
};

const checkEmployersCount = () => {
  if (!wrapper) {
    return;
  }

  const employers = wrapper.querySelectorAll('.account-aside__employers-item');
  const employersCount = employers.length;
  const addBtn = wrapper.querySelector('.account-aside__btn-add');
  if (!addBtn) {
    return;
  }

  if (employersCount >= MAX_EMPLOYERS) {
    addBtn.disabled = true;
  } else {
    addBtn.disabled = false;
  }
};

const onEmployerFormSubmit = (evt) => {
  evt.preventDefault();
  const target = evt.target;
  const employer = target.closest('.account-aside__employers-item');
  if (!employer) {
    return;
  }

  const employerInfo = employer.querySelector('.employer-info');
  if (employerInfo) {
    const empPhone = target.querySelector('input[type="tel"]').value;
    const empName = target.querySelector('input[type="text"]').value;
    const phoneItem = employerInfo.querySelector('.employer-info__phone');
    const nameItem = employerInfo.querySelector('.employer-info__name');
    phoneItem.textContent = empPhone;
    nameItem.textContent = empName;
  }

  employer.classList.remove('active', 'js-not-ready');

  checkEmployersCount();
  accordions.updateAccordionsHeight();
};

const addEmployer = () => {
  if (!wrapper) {
    return;
  }

  const place = wrapper.querySelector('.account-aside__employers-list');

  if (!place) {
    return;
  }

  const template = createEmployerTemplate();
  const element = createElement(template);
  const form = element.querySelector('[data-validate]');
  place.prepend(element);
  const Form = new FormsValidate(form, {
    validationSuccessCallback: onEmployerFormSubmit,
  });
  Form.init();
};

const closeAllEmployers = () => {
  if (!wrapper) {
    return;
  }

  const activeEmployers = wrapper.
      querySelectorAll('.account-aside__employers-item.active');

  activeEmployers.forEach((employer) => {
    employer.classList.remove('active');
    if (employer.classList.contains('js-not-ready')) {
      employer.remove();
    }
  });
  accordions.updateAccordionsHeight();
};

const onAsideClick = (evt) => {
  const target = evt.target;

  if (!target) {
    return;
  }

  const editBtn = target.closest('.employer-info__edit-btn');
  if (editBtn) {
    evt.preventDefault();
    closeAllEmployers();
    const employer = editBtn.closest('.account-aside__employers-item');
    if (employer) {
      employer.classList.add('active');
    }

    accordions.updateAccordionsHeight();
  }

  const addBtn = target.closest('.account-aside__btn-add');
  if (addBtn) {
    evt.preventDefault();
    closeAllEmployers();
    addEmployer();
    accordions.updateAccordionsHeight();
  }

  const deleteBtn = target.closest('.employer-form__btn--delete');
  if (deleteBtn) {
    evt.preventDefault();
    const employer = deleteBtn.closest('.account-aside__employers-item');
    if (employer) {
      employer.remove();
    }
  }

  checkEmployersCount();
};

const initAccountAside = () => {
  if (!wrapper) {
    return;
  }

  checkEmployersCount();
  wrapper.addEventListener('click', onAsideClick);
};

export {initAccountAside, onEmployerFormSubmit};
